import React, { createContext, useContext, useReducer } from 'react';

const defaultSteps = [
  {
    type: 'MODELS',
    name: 'Modelos elegíveis',
    description: 'Selecione uma versão',
    disabled: false,
    order: 0
  },
  {
    type: 'REVIEW',
    name: 'Revisão',
    description: 'Revise seu pedido',
    disabled: true,
    order: 1
  },
  {
    type: 'FORM',
    name: 'Formulário',
    description: 'Preencha o formulário',
    disabled: true,
    order: 2
  }
];

export const ACTIONS = {
  INITIALIZE_STEPS: 'INITIALIZE_STEPS',
  INITIALIZE_LIST_STEPS: 'INITIALIZE_LIST_STEPS',
  RESET_STATE: 'RESET_STATE',
  SET_CURRENT_STEP: 'SET_CURRENT_STEP',
  SET_CUSTOMER_VEHICLES: 'SET_CUSTOMER_VEHICLES',
  SET_FINAL_STEP_COMPLETED: 'SET_FINAL_STEP_COMPLETED',
  UPDATE_LIST_STEP: 'UPDATE_LIST_STEP',
  UPDATE_FORM_FIELDS: 'UPDATE_FORM_FIELDS',
  SET_STATUS: 'SET_STATUS'
};

const initialState = {
  currentStep: 0,
  listSteps: [],
  customerVehicles: [],
  isFinalStepCompleted: false,
  formfields: {},
  status: 'default'
};

const DirectSalesContext = createContext();

const directSalesReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_CURRENT_STEP:
      return { ...state, currentStep: action.payload, selectedVehicleName: null };
    case ACTIONS.SET_FINAL_STEP_COMPLETED:
      return { ...state, isFinalStepCompleted: action.payload };
    case ACTIONS.SET_CUSTOMER_VEHICLES:
      return { ...state, customerVehicles: action.payload };
    case ACTIONS.INITIALIZE_LIST_STEPS:
      return { ...state, listSteps: defaultSteps };
    case ACTIONS.UPDATE_LIST_STEP:
      return { ...state, listSteps: action.payload };
    case ACTIONS.UPDATE_FORM_FIELDS:
      return { ...state, formFields: action.payload };
    case ACTIONS.SET_STATUS:
      return { ...state, status: action.payload };
    case ACTIONS.INITIALIZE_STEPS:
      return { ...initialState, customerVehicles: state.customerVehicles, listSteps: defaultSteps };
    case ACTIONS.RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

export const DirectSalesProvider = ({ children }) => {
  const [state, dispatch] = useReducer(directSalesReducer, initialState);

  return (
    <DirectSalesContext.Provider value={{ state, dispatch }}>{children}</DirectSalesContext.Provider>
  );
};

export const useDirectSales = () => useContext(DirectSalesContext);
